import { INSIGHT_SERVICE_URL } from 'constants/insight-service';
import axiosInstance from '../utils/axios-instance';

export const getResources = async (locale: string) => {
    const response = await axiosInstance.get(`${INSIGHT_SERVICE_URL}/v1/translations/all?lang=${locale}`);

    return response.data;
};
